import { createTheme } from "@mui/material/styles";
import { globalBackgroundColor } from "./components/constants";

const theme = createTheme({
  palette: {
    background: {
      // default: "transparent", // Set the background to be transparent
      default: globalBackgroundColor,
    },
    primary: {
      main: "#014A32",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fff",
      contrastText: "#014A32",
    },
    text: {
      primary: "#014A32",
      secondary: "#46505A",
    },
  },
  typography: {
    fontFamily: "Ubuntu, Arial, sans-serif",
  },
  overrides: {
    MuiFormLabel: {
      root: {
        "&$focused": {
          color: "#014A32",
        },
      },
    },
  },
});

export default theme;
